/**
 * Created by sairam on 25/04/17.
 */
import { ERASE_CURRENT_USER_DATA } from 'containers/Admin/actionTypes';
import { fromJS } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import { getItem, setItem } from 'utils/localStorage';
import * as service from './../../common/services/session.service';

import { SESSION_VALID, SESSION_LOGOUT } from './SessionActionTypes';


export function isSessionValid() { // eslint-disable-line
  return (dispatch) => {
    service.isSessionValid((err, result) => {
      if (err) {
        dispatch({
          type: SESSION_LOGOUT,
        });
      } else {
        const token = result.session.idToken.jwtToken;
        dispatch({
          type: SESSION_VALID,
          session: fromJS(result.session),
          user: fromJS(result.user),
          attributes: fromJS(result.attributes),
          token,
        });
      }
    });
  };
}

export function logoutUser(zoneinfo) { // eslint-disable-line
  return (dispatch) => {
    const temp = [{ Name: 'profile', Value: 'PENDING' }];
    const admin = getItem('user_cred');
    if (admin && admin.length > 5 && zoneinfo === 'ADMIN') {
      service.updateUserAttributes(temp, (err) => {
        if (!err) {
          service.logoutUser(() => {
            window.sessionStorage.setItem('user', null);
            setItem('user_cred', '');
            setItem('localZone', '');
            dispatch({
              type: SESSION_LOGOUT,
            });
          });
        }
      });
    } else {
      service.logoutUser(() => {
        window.sessionStorage.setItem('user', null);
        setItem('user_cred', '');
        setItem('localZone', '');
        dispatch({
          type: SESSION_LOGOUT,
        });
      });
    }
  };
}

export function logoutCurrentUserForAdmin() { // eslint-disable-line
  return (dispatch) => {
    const admin = getItem('user_cred');
    if (admin && admin.length > 5) {
      const temp = [{ Name: 'profile', Value: 'PENDING' }];
      service.updateUserAttributes(temp, (err) => {
        if (!err) {
          // window.sessionStorage.setItem('kiro', false);
          setItem('user', '');
          setItem('user_cred', '');
          setItem('localZone', '');
          dispatch({
            type: ERASE_CURRENT_USER_DATA,
          });
        }
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/Session/Session.actions.js